export const historyOf = state => key => {
  return state.list.items.find(i => i.id === key).history
}

export const query = state => {
  return {
    to: state.to,
    from: state.from,
    id: state.id,
    invoiceId: state.invoiceId,
    serie: state.serie,
    number: state.number,
    documentProvider: state.documentProvider,
    documentClient: state.documentClient,
    amount: state.amount === null ? undefined : state.amount,
    status: state.status === -1 ? undefined : state.status,
    delegation: state.delegation,
    newStatus: state.newStatus === null ? undefined : state.newStatus
  }
}

export const getSelectedIds = (state, getters) => {
  return getters['list/getSelectedItems'].map(x => {
    return x.id
  })
}

export const loaded = (state) => {
  return state.loaded
}
